import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TimeLineEvent } from 'src/app/shared/models/time-line-event';

@Component({
  selector: 'app-time-line',
  templateUrl: './time-line.component.html',
  styleUrls: ['./time-line.component.scss'],
  standalone: false,
})
export class TimeLineComponent {
  @Input() events: TimeLineEvent[] = [];
  @Input() alignItems: string = 'alternate'; //top | bottom | alternate
  @Input() imgPath: string = null;
  @Input() dateFormat: string = 'dd/MM/yyyy';
  @Input() itemWidth: string = '90px';
  @Input() fontColor: string = 'black';

  asd: TimeLineEvent[] = [];

  constructor(private datePipe: DatePipe) {}

  getContainerClass(i: number, event: TimeLineEvent) {
    const alignCssClass =
      (this.alignItems === 'bottom' ||
      (this.alignItems === 'alternate' && i % 2 === 0)
        ? 'bottom'
        : '') + (this.alignItems === 'alternate' ? ' alternate' : '');
    const highlightCssClass = event.highlight ? 'highlight-item' : '';

    return alignCssClass + ' ' + highlightCssClass;
  }

  getDateFormat(date: string) {
    return date ? this.datePipe.transform(date, this.dateFormat) : '-';
  }
}
